import React from 'react';

function formatPreviewNumber(value) {
  const number = Number(value || 0);
  return Number.isFinite(number) ? number.toLocaleString() : '0';
}

function getSourceLabel(source) {
  if (source === 'bilibili') return 'B站';
  if (source === 'local') return '本地';
  return '未查到';
}

function hideBrokenImage(event) {
  event.currentTarget.style.display = 'none';
}

function ImportPreviewUser({ row }) {
  const user = row.resolved_user || {};
  const account = row.account || {};
  const source = user.source || (account.bilibili_uid ? 'local' : 'none');
  const uid = user.bilibili_uid || row.bilibili_uid || '';
  const name = user.bilibili_uname || row.bilibili_uname || account.bilibili_uname || '';
  const face = user.bilibili_face || account.bilibili_face || '';
  const websiteUsername = user.website_username || account.username || '';
  const websiteEmail = user.website_email || account.email || '';
  const walletId = user.wallet_id || account.wallet_id || '';
  const currentPoints = user.current_points ?? account.points_balance ?? 0;
  const currentMovieTickets = user.current_movie_tickets ?? account.movie_ticket_balance ?? 0;

  return (
    <div className={`preview-user ${source === 'none' ? 'missing' : ''}`}>
      <div className="preview-user-uid-row">
        <span className="preview-user-uid">UID {uid || '-'}</span>
        <span className={`preview-user-source ${source}`}>{getSourceLabel(source)}</span>
      </div>
      <div className="preview-user-card">
        {face && (
          <img
            src={face}
            alt=""
            className="preview-user-avatar"
            referrerPolicy="no-referrer"
            onError={hideBrokenImage}
          />
        )}
        <div className="preview-user-info">
          <strong>{name || '未查到用户信息'}</strong>
          <span>
            {websiteUsername
              ? `网站：${websiteUsername}${websiteEmail ? ` / ${websiteEmail}` : ''}`
              : '未绑定网站用户'}
          </span>
          <span>
            {walletId ? `钱包 #${walletId}` : '未登记钱包'}
            {' · '}
            积分 {formatPreviewNumber(currentPoints)}
            {' · '}
            电影票 {formatPreviewNumber(currentMovieTickets)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default ImportPreviewUser;
